<div class="segmented-controller">
  @for (option of options(); track option.value) {
    <button
      joii-inline-button
      type="button"
      variant="secondary"
      [attr.data-automationid]="option.automationId ?? null"
      [active]="value() === option.value"
      [disabled]="formDisabled()"
      [prefixIcon]="option.leftIcon"
      [suffixIcon]="option.rightIcon"
      (click)="selectOption(option.value)"
      [size]="size()"
      [fullWidth]="fullWidth()"
      class="button"
    >
      {{ option.label }}
    </button>
  }
</div>
